import React from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  return <section className="bg-sky-100 text-gray-900 pt-8 pb-16 px-4" data-id="element-47">
      <div className="max-w-5xl mx-auto text-center" data-id="element-48">
        <div className="inline-block bg-yellow-400 text-blue-900 font-bold px-4 py-1 rounded-full text-sm mb-6 shadow-sm" data-id="element-49">
          🌙 Para mamás y papás de bebés (0 a 24 meses)
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-4 leading-tight text-gray-900" data-id="element-50">
          MegaPack Dormir Mejor Desde el Amor
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 mb-8 font-medium max-w-3xl mx-auto" data-id="element-51">
          La guía respetuosa y científica para ayudar a tu bebé a dormir mejor
          sin dejarlo llorar, sin métodos invasivos y sin romper el vínculo
        </p>

        <div className="mb-8" data-id="element-52">
          <img src="https://cdn.magicpatterns.com/uploads/7JqcfQigPgCUz8cnpAX8jJ/mockup_final_dormir_mejor_desde_el_amor.png" alt="MegaPack Dormir Mejor Desde el Amor" className="w-full max-w-lg mx-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-53" />
        </div>

        <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6 mb-10 border border-white/80 shadow-sm max-w-3xl mx-auto" data-id="element-54">
          <p className="text-lg md:text-xl font-semibold text-gray-800" data-id="element-55">
            Dormir mejor es posible, sin culpa y sin violencia emocional.{' '}
            <br className="hidden md:block" data-id="element-56" />
            No más probar "todo" sin saber qué funciona.
          </p>
        </div>

        <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" className="w-full md:w-auto text-xl md:text-2xl shadow-[0_0_20px_rgba(39,194,39,0.5)] animate-bounce" data-id="element-57">
          👉 SÍ, QUIERO ACCEDER AHORA
        </Button>

        <p className="mt-4 text-sm text-gray-600 flex items-center justify-center gap-2 font-medium" data-id="element-58">
          ✅ Garantía de satisfacción de 7 días
        </p>
      </div>
    </section>;
}